import { bool, shape, string, func } from "prop-types"
import { Select } from "components/ui"

const QuestionKind = ({ question, onKindChanged, editing }) => {
  return (
    <div className="f-1">
      <label htmlFor="kind">Type</label>
      {editing ? (
        <div className="action-drawer p-1">{question.kindLabel}</div>
      ) : (
        <Select
          name="kind"
          id="kind"
          value={question.kind}
          onChange={onKindChanged}
          options={[
            {
              value: "text",
              label: "Text"
            },
            {
              value: "paragraph",
              label: "Paragraph"
            },
            {
              value: "singlecheckbox",
              label: "Single checkbox"
            },
            {
              value: "dropdownsingle",
              label: "Dropdown"
            },
            {
              value: "dropdownmult",
              label: "Checkboxes"
            }
          ]}
        />
      )}
    </div>
  )
}

QuestionKind.propTypes = {
  question: shape({ kind: string }),
  onKindChanged: func,
  editing: bool
}

export default QuestionKind
